/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import { makeAuthenticatedPostForFile } from "../../utils/fetchUtils";
import { PARSE_RESUME } from "../../utils/constants";
import useWindowWidth from "../../utils/windowWidth";

function ResumeUploadingPage() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const { purpose } = useParams();
  const [isUploading, setIsUploading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const redirectPath = purpose === "recommend" ? "/jobs" : "/opportunity/chatbot";
  const resumeFile = (location.state as { file?: File } | null)?.file;

  useEffect(() => {
    let isMounted = true;

    const uploadResume = async () => {
      if (!resumeFile) {
        setErrorMessage("Resume file not found. Please upload it again.");
        setIsUploading(false);
        return;
      }

      try {
        const data = new FormData();
        data.append("file", resumeFile);
        await makeAuthenticatedPostForFile(PARSE_RESUME, data);

        if (isMounted) {
          navigate(redirectPath, { replace: true });
        }
      } catch (error) {
        if (isMounted) {
          setErrorMessage("We could not process your resume. Please try again.");
          setIsUploading(false);
        }
      }
    };

    uploadResume();

    return () => {
      isMounted = false;
    };
  }, [navigate, redirectPath, resumeFile]);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);


  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage=""/>
        <div className="doc-container" role="main" tabIndex={-1}>
          <div className="component-container center uploading resume-illustration-div">
          <img src="/resume-parsing-illustration.webp" alt="Illustration of resume parsing process" className="resume-img"/>
          <h1 className="display-title center" ref={mainRef} tabIndex={-1}>{isUploading ? "Processing Your Uploaded File" : "Upload Interrupted"}</h1>
          <p>{errorMessage || "Parsing your resume to extract relevant information to assist you better. You will be redirected automatically when it is ready."}</p>
            {!isUploading && errorMessage && (
              <button className="center upload-button" onClick={() => navigate(redirectPath)}>
                Go back
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResumeUploadingPage;
